export const page = {
    width: '100%',
    height: '100%',
    overflowY: 'auto',
    background: '#ffffff',
    color: '#111',
    fontFamily: 'system-ui, sans-serif',
    padding: '10px',
};
export const container = {height: "100%", width: "100%", margin: '0 auto', padding: '40px 24px 80px', overflow: "auto"};
export const headerRow = {display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '24px'};
export const h1 = {margin: 0, fontSize: '28px'};
export const button = {
    padding: '10px 20px',
    border: '1px solid #ddd',
    background: '#fff',
    color: '#111',
    cursor: 'pointer',
    fontSize: '14px',
    textDecoration: 'none',
    display: 'inline-block',
};
export const primaryButton = {...button, background: '#111', color: '#fff', border: '1px solid #111'};
export const input = {
    width: '100%',
    padding: '10px 12px',
    border: '1px solid #ddd',
    fontSize: '14px',
    fontFamily: 'inherit',
    color: '#111',
    background: '#fff',
};

export const input2 = {
    width: '100%',
    padding: '10px 12px',
    border: '1px solid #ddd',
    fontSize: '14px',
    fontFamily: 'inherit',
    color: '#111',
    background: '#fff',
    marginBottom: '12px',
};
export const label = {display: 'block', fontSize: '14px', fontWeight: 600, margin: '20px 0 6px'};
export const hint = {fontSize: '13px', color: '#777', margin: '6px 0 0'};
export const rowStyle = {
    display: 'flex',
    alignItems: 'center',
    gap: '16px',
    padding: '12px',
    border: '1px solid #eaeaea',
    borderRadius: '12px',
    marginBottom: '10px',
};

export const thumbStyleAdminList = {
    width: '56px',
    height: '56px',
    objectFit: 'cover',
    borderRadius: '8px',
    background: '#f5f5f5'
};

export const overlayStyle = {
    position: 'fixed',
    inset: 0,
    background: 'rgba(0,0,0,0.4)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 50,
    padding: '24px',
};

export const headerStyle = {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '16px',
};

export const panelStyle = {
    background: '#fff',
    borderRadius: '12px',
    padding: '24px',
    width: '100%',
    maxWidth: '720px',
    maxHeight: '80vh',
    overflowY: 'auto',
    boxShadow: '0 20px 60px rgba(0,0,0,0.2)',
    fontFamily: 'system-ui, sans-serif',
    color: '#111',
};

export const gridStyle = {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fill, minmax(140px, 1fr))',
    gap: '12px',
};

export const cardStyle = {
    position: 'relative',
    border: '1px solid #eaeaea',
    borderRadius: '8px',
    padding: '8px',
};

export const thumbStyle = {
    width: '100%',
    height: '100px',
    objectFit: 'cover',
    borderRadius: '6px',
    background: '#f5f5f5',
    display: 'block',
};

export const badgeStyle = {
    position: 'absolute',
    top: '12px',
    left: '12px',
    background: 'rgba(0,0,0,0.7)',
    color: '#fff',
    fontSize: '10px',
    padding: '2px 6px',
    borderRadius: '4px',
};

export const rootStyleUniversum = {
    position: 'relative',
    width: '100vw',
    height: '100vh',
    background: '#ffffff',
    color: '#111',
    fontFamily: 'system-ui, sans-serif',
};

export const panelStyleUniversim = {
    position: 'absolute',
    top: '20px',
    left: '20px',
    width: '300px',
    maxHeight: 'calc(100vh - 40px)',
    overflowY: 'auto',
    padding: '16px',
    background: 'rgba(255,255,255,0.95)',
    border: '1px solid #eaeaea',
    borderRadius: '12px',
    boxShadow: '0 10px 30px rgba(0,0,0,0.08)',
    zIndex: 5,
};

export const listItemStyle = {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: '8px',
    padding: '8px 10px',
    marginBottom: '6px',
    border: '1px solid #eaeaea',
    borderRadius: '8px',
    cursor: 'pointer',
    fontFamily: 'inherit',
    fontSize: '14px',
    color: '#111',
    textAlign: 'left',
};


